// "Fixed-Size Chunks Are Killing Your RAG" — Adaptive Chunking short.
// Ingest-time chunking (distinct from the hybrid-search / RRF retrieval videos).
// Cold Compute / Neon kit. ~96s @ 30fps.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; starts are contiguous.
// Each scene's duration ≈ round((lastCaption.fromSec + ~6) * 30) so the last
// caption is never cut off and there is no dead air. See script.ts for fromSec.
export const SCENE = {
  hook: { start: 0, duration: 210 }, //         0:00–0:07   fixed-size chunking shreds meaning
  problem: { start: 210, duration: 360 }, //     0:07–0:19   a function split mid-body retrieves nothing
  intuition: { start: 570, duration: 360 }, //   0:19–0:31   cut at the seams, not every 2048 chars
  approach: { start: 930, duration: 390 }, //    0:31–0:44   read the type, then pick a strategy
  code: { start: 1320, duration: 525 }, //       0:44–1:01   the real switch + tree-sitter boundaries
  langs: { start: 1845, duration: 360 }, //      1:01–1:13   13 grammars, comments attached, no LLM
  payoff: { start: 2205, duration: 360 }, //     1:13–1:25   ~512-token target, structural chunks
  outro: { start: 2565, duration: 300 }, //      1:25–1:35
} as const;

export const TOTAL_DURATION =
  SCENE.hook.duration +
  SCENE.problem.duration +
  SCENE.intuition.duration +
  SCENE.approach.duration +
  SCENE.code.duration +
  SCENE.langs.duration +
  SCENE.payoff.duration +
  SCENE.outro.duration; // 2865 = 95.5s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
